//X Label detailed function

export function labeledXAxis(selection, props) {
  const {
    xAxisLabelFill,
    xAxisLabelOffset,
    xAxisTickFontSize,
    xAxisLabelFontSize,
    AxisTickFontFill,
    AxisTickLineStroke,
    AxisDomainLineStroke,
    xAxisTickDensity,
    xScale,
    innerHeight,
    innerWidth,
    dataGraph,
  } = props;

  //const xAxisTickFormat = d3.timeFormat("%m/%d");

  const xAxis = d3
    .axisBottom(xScale)
    // .tickFormat(function (d) {
    //   return d;
    // })
    .ticks(innerWidth / 76)
    // .tickValues(
    //   data.map(function (d) {
    //     return d.date;
    //   })
    // )
    .tickSize(12);
  //.tickSizeOuter(0);

  let xAxisG = selection.selectAll(".AxisX").data([null]);
  xAxisG = xAxisG
    .enter()
    .append("g")
    .attr("class", "AxisX")
    .merge(xAxisG)
    .attr("transform", `translate(0, ${innerHeight})`);

  xAxisG.call(xAxis);
  xAxisG
    .selectAll(".tick text")
    .attr("opacity", 1)
    .style("font-size", xAxisTickFontSize)
    .attr("fill", AxisTickFontFill);
  xAxisG
    .selectAll(".tick line")
    .attr("stroke", AxisTickLineStroke)
    // .attr("x1", xScale(d.date))
    // .attr("x2", xScale(d.date))
    .attr("y1", "0px")
    .attr("y2", innerHeight)
    .attr("transform", `translate(0, ${-innerHeight})`);
  xAxisG.select(".domain").attr("stroke", AxisDomainLineStroke);

  //Labels
  // const xAxisLabel = xAxisG.selectAll(".axisLabelX").data([null]);
  // xAxisLabel
  //   .enter()
  //   .append("text")
  //   .attr("class", "axisLabelX")
  //   .merge(xAxisLabel)
  //   .text("Definition of values (%)")
  //   .attr("text-anchor", "middle")
  //   .attr("fill", xAxisLabelFill)
  //   .attr("x", innerWidth / 2)
  //   .attr("y", xAxisLabelOffset)
  //   .style("font-size", xAxisLabelFontSize);
}
